import { useContext } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Logo, Icon } from '@collegebacker/backer-ui/ui'

import { SessionContext } from 'context/SessionProvider'
import { CreateFundStep } from '../createFundInterfaces'
import { getQuery } from 'hooks/getQuery'
import { BackLink } from 'components/button/BackLink'

import styles from './CreateFundHeader.module.scss'
import { buildPath } from 'routes'


const CreateFundHeader = ({
  step,
  backStep,
  hideBack=false,
  animationBack,
  skipTo
}
: {
  step: CreateFundStep
  backStep: string | ''
  hideBack?: boolean
  animationBack?: any
  skipTo?: any
}) => {
  const context = useContext(SessionContext)
  const history = useHistory()
  const query = getQuery()
  const referrer = query.get('referrer')
  const firstStep = query.get('firstStep')
  const firstOnboardingStep = step === firstStep || step === 'collect-name'

  const showBackArrow = (context.mobileAppFromV(2) && !firstOnboardingStep) || (!context.mobileAppFromV(2))

  return (
    <div
      className={styles.container}
    >
      <Link to={buildPath('dashboard')} className={styles.logoLink}>
        <Logo className={styles.backerLogo} />
      </Link>

      <div className={styles.backContainer}>
        {(showBackArrow && !hideBack) && (
          animationBack ? (
            <button className={styles.animationBackArrow} onClick={animationBack}>
              <Icon name="arrow-left" />
            </button>
          ) : (
          <BackLink
            callback={firstOnboardingStep ?
              () => history.replace(referrer ? decodeURIComponent(referrer) : null || buildPath('dashboard')) :
              () => history.push({
                pathname: buildPath('createFund', { step: backStep }),
                search: referrer ? `?referrer=${referrer}` : ''
              })
            }
            modifier="no-padding"
          />)
          )
        }
      </div>

      {
        skipTo && (
        <button
          onClick={skipTo}
          className={styles.questionMark}
        >
          Skip
        </button>
        )
      }
    </div>
  )
}


export default CreateFundHeader
